import { Component } from '@angular/core';

@Component({
    selector: 'app-full-screen-loading',
    standalone: true,
    templateUrl: './full-screen-loading.html',
    styleUrls: ['./full-screen-loading.scss']
})
export class FullScreenLoading {
}
